import { injectIntl, intlShape } from '@edx/frontend-platform/i18n'
import { useEffect, useState } from 'react'
import CourseDropdownCard from '../../../components/CourseDropdownCard'
import CourseExploreCard from '../../../components/CourseExploreCard'
import { useHeaderTitle, useHeaderBackLink } from '@blend-ed/blendx-platform';
import useFetchProgramById from '../../../hooks/useFetchProgramById'
import useLearnerHomeInit from '../../../hooks/useLearnerHomeInit'
import { getCoursesBasedOnCourseIdsEnrolled } from '../../../utils/getCourseDataByCourseIdsEnrolled'
import { withParams } from '@blend-ed/blendx-platform/utils'
import messages from './messages'

function LearnerProgram(props) {
    const { intl, params } = props
    const { setTitle } = useHeaderTitle()
    const { setBackLink } = useHeaderBackLink();
    const [program, setProgram] = useState({
        name: "",
        description: "",
        image: "",
        duration: "",
        programCourses: [],
        about: "",
        achievements: null
    })
    const [programCourses, setProgramCourses] = useState([])

    const { data } = useFetchProgramById(params.id)
    const { data: learnerHomeInitData } = useLearnerHomeInit()

    // fetch and setup program data
    useEffect(() => {
        if (data && learnerHomeInitData) {
            setProgram(data)

            const coursesInProgram = data.programCourses.map((course) => {
                return course.course.openedxCourseId
            })

            // Get courses data and sort by courseName using natural sort
            const sortedCourses = getCoursesBasedOnCourseIdsEnrolled(coursesInProgram, learnerHomeInitData)
                .sort((a, b) => a.courseName.localeCompare(b.courseName, undefined, { numeric: true, sensitivity: 'base' }));

            setProgramCourses(sortedCourses)
            setTitle(data.name)
        }
        setBackLink(`/learning`)
    }, [data, learnerHomeInitData])

    return (
        <main className='program-single__wrapper'>
            <div className="program-single__left">
                <div className="program-single__description-wrapper">
                    <span className='program-single__description-title'>{intl.formatMessage(messages.description)}</span>
                    {program.description ?
                        <p className='program-single__description-text'>{program.description}</p>
                        : <p className='program-single__description-text'>{intl.formatMessage(messages.noDescriptionFound)}</p>
                    }
                    <div className='program-single__description-about'>
                        <span className='program-single__description-title'>{intl.formatMessage(messages.about)}</span>
                        {program.about ?
                            <p className='program-single__description-text'>{program.about}</p>
                            : <p className='program-single__description-text'>{intl.formatMessage(messages.noAboutFound)}</p>}
                    </div>
                    <div className="program-single__content">
                        <h3 className='program-single__description-title'>{intl.formatMessage(messages.contents)}</h3>
                        {programCourses.length > 0 ?
                            <div className="courses-section">
                                {programCourses.map((course, index) => {
                                    return <CourseDropdownCard
                                        key={index}
                                        img={course.bannerImgSrc}
                                        title={course.courseName}
                                        description={course.description}
                                        link={course.resumeLink || course.homeLink}
                                        startDate={course.startDate}
                                    />
                                })}
                            </div>
                            : <p className='program-single__description-text'>{intl.formatMessage(messages.noCoursesFound)}</p>
                        }
                    </div>
                </div>
            </div>
            <div className="program-single__right">
                <CourseExploreCard
                    preview={program.image}
                    price={program.price}
                    estimatedTime={`${program.duration} ${program.durationMetric}`}
                    cardType="program"
                    courseCount={`${program.programCourses.length} ${intl.formatMessage(messages.courses)}`}
                    achievements={program.achievements}
                    alreadyEnrolled={true}
                    onDiscoverPage={false}
                />
            </div>
        </main>
    )
}

LearnerProgram.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(withParams(LearnerProgram));